(function () {
  var cartItemCount = 0;
  var isHovered = false;

  // Fetch cart
  document.addEventListener("DOMContentLoaded", function () {
    fetchCart();
  });

  /**
   * =================================================================
   *  Library functions
   * =================================================================
   */

  // Set Cookie
  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  // Get Coookie
  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // Debounce
  function debounce(fn, delay = 300) {
    return (args) => {
      setTimeout(() => {
        fn.apply(this, args);
      }, delay);
    };
  }

  // Defaults selector
  var defaults = {
    cartModal: ".js-ajax-cart-modal",
    cartModalContent: ".js-ajax-cart-modal-content",
    cartModalClose: ".js-ajax-cart-modal-close",
    cartDrawer: ".js-ajax-cart-drawer",
    cartDrawerContent: ".js-ajax-cart-drawer-content",
    cartDrawerClose: ".js-ajax-cart-drawer-close",
    cartDrawerTrigger: ".js-ajax-cart-drawer-trigger",
    cartOverlay: ".js-ajax-cart-overlay",
    cartCounter: ".js-ajax-cart-counter",
    cartCounterMobile: ".js-ajax-cart-counter-mobile",
    addToCart: ".js-ajax-add-to-cart",
    cartBasketIcon: "[js-ajax-basket-icon]",
    cartBasketMobileIcon: "[js-ajax-basket-icon-mobile]",
    sidecartBasketMobileIcon: ".side-cart",
    cartBasketDesktopIcon: "[js-ajax-basket-icon] .bm-cart",
  };

  // Cart Elements
  let cartDrawer = document.querySelector(defaults.cartDrawer);
  let cartDrawerContent = document.querySelector(defaults.cartDrawerContent);
  let cartDrawerClose = document.querySelector(defaults.cartDrawerClose);
  let cartOverlay = document.querySelector(defaults.cartOverlay);
  let cartCounter = document.querySelector(defaults.cartCounter);
  let cartCounterMobile = document.querySelector(defaults.cartCounterMobile);
  let cartBasketIcon = document.querySelector(defaults.cartBasketIcon);
  let cartBasketMobileIcon = document.querySelectorAll(defaults.cartBasketMobileIcon);
  let sidecartBasketMobileIcon = document.querySelector(defaults.sidecartBasketMobileIcon);
  let cartBasketDesktopIcon = document.querySelector(defaults.cartBasketDesktopIcon);

  let htmlSelector = document.documentElement;

  /**
   * =================================================================
   *  Cart Object
   * =================================================================
   */
  var MainCart = {
    // ------- Cart Drawer -------
    openCartDrawer() {
      if (
        window.location.pathname != "/cart" &&
        document.body.classList.contains("STO-T35-Homepage")
      ) {
        // .STO-T35-Homepage
        document.querySelector(`.js-ajax-cart-drawer`)
          ? (document.querySelector(`.js-ajax-cart-drawer`).style.display = "block")
          : "";

        cartDrawer.classList.add("is-open");
        document.body.classList.add("open-cart__drawer");

        // Remove other open modals
        // var searchResult = document.querySelector(".navbar-nav .predictive-search-container");
        // if (searchResult) {
        //   searchResult.style.display = "none";
        // }

        // Remove open class for login modal
        var openLoginModal = document.querySelector(".navbar-nav .dropdown-grid.open");
        openLoginModal?.classList.remove("open");
      }
    },

    closeCartDrawer() {
      if (document.body.classList.contains("STO-T35-Homepage")) {
        cartDrawer.classList.remove("is-open");
        document.body.classList.remove("open-cart__drawer");
        cartDrawer.style.display = "none";
        document.body.classList.remove("cart__open-with-fixed");
      }
    },

    clearCartDrawer() {
      if (cartDrawerContent) {
        cartDrawerContent.innerHTML = "";
      }
    },

    // ------- Cart Overlay -------
    openCartOverlay() {
      cartOverlay.classList.add("is-open");
      htmlSelector.classList.add("is-locked");
    },

    closeCartOverlay() {
      cartOverlay.classList.remove("is-open");
      htmlSelector.classList.remove("is-locked");
    },

    // Show modal onPageload
    showModalOnPageload() {
      var isDesktop = window.matchMedia("(min-width: 1024px)");

      // If cart modal already closed
      if (localStorage.getItem("isCartModalClosed")) return;

      // Check if the media query matches
      if (isDesktop.matches) {
        setTimeout(function () {
          if (document.body.classList.contains("STO-T35-Homepage")) {
            MainCart.openCartDrawer();
          }
        }, 2000);
      } else {
        setTimeout(function () {
          if (document.body.classList.contains("STO-T35-Homepage")) {
            MainCart.openCartDrawer();
          }
        }, 1000);
      }

      localStorage.setItem("isCartModalClosed", true);
    },

    // ------- Update Cart Quantity -------
    updateCartQuantity(lineItemIndex, quantity, lineItemId) {
      //return true;
      $.ajax({
        type: "POST",
        url: "/cart/change.js", // Replace with your actual URL to update the cart
        data: {
          line: lineItemIndex,
          quantity: quantity,
        },
        success: function (response) {
          const responseData = JSON.parse(response);
          if (cartCounter) {
            cartCounter.innerHTML = responseData.item_count;
            cartCounterMobile.innerHTML = responseData.item_count;
          }
          fetchCart(); // Refresh the cart
        },
        error: function (error) {
          // ToDo if error revert last updat either hit minus or plus
          let quantityElement = document.querySelector(
            `.quantity-value[data-line-item-id="${lineItemId}"]`
          );

          if (quantityElement) {
            quantityElement.innerHTML = quantity - 1;
          }

          fetchCart();
          addToCartFail();
        },
      });
    },

    increaseQuantity(lineItemId) {
      var quantityElement = document.querySelector(
        `.quantity-value[data-line-item-id="${lineItemId}"]`
      );
      var lineItemIndex = quantityElement.dataset.lineIndex;
      var quantity = parseInt(quantityElement.innerText);
      quantityElement.innerText = ++quantity;
      MainCart.updateCartQuantity(lineItemIndex, quantity, lineItemId);
    },

    decreaseQuantity(lineItemId) {
      var quantityElement = document.querySelector(
        `.quantity-value[data-line-item-id="${lineItemId}"]`
      );
      var quantity = parseInt(quantityElement.innerText);
      var lineItemIndex = quantityElement.dataset.lineIndex;
      quantityElement.innerText = --quantity;
      MainCart.updateCartQuantity(lineItemIndex, quantity, lineItemId);
    },
  };

  /**
   * =================================================================
   *  Cart drawer
   * =================================================================
   */

  // Drawer close icon
  cartDrawerClose?.addEventListener("click", function () {
    MainCart.closeCartDrawer();
    localStorage.setItem("isCartModalClosed", true);
  });

  // dodati overflow na body di treba, cart is empty stanje
  cartOverlay?.addEventListener("click", function () {
    MainCart.closeCartDrawer();
    MainCart.closeCartOverlay();
  });

  /**
   * =================================================================
   * Show cart modal On hover and hide as well
   * =================================================================
   */
  var isCartPage = window.location.pathname == "/cart";
  // On cart icon hover
  cartBasketIcon?.addEventListener("mouseover", function () {
    // if (cartItemCount > 0) {
    MainCart.openCartDrawer();
    isHovered = true;

    // }
  });

  // On mouseout
  document.body.addEventListener("mouseover", function (e) {
    if (
      !e.target.closest(".ajax-cart__drawer") &&
      !e.target.closest("[js-ajax-basket-icon-mobile]") &&
      !e.target.closest("[js-ajax-basket-icon]") &&
      !e.target.closest(".side-cart") &&
      isHovered
    ) {
      MainCart.closeCartDrawer();
    }
  });

  // Close on click
  document.body.addEventListener("click", function (e) {
    if (
      !e.target.closest(".ajax-cart__drawer") &&
      !e.target.closest("[js-ajax-basket-icon-mobile]") &&
      !e.target.closest("[js-ajax-basket-icon]") &&
      window.innerWidth < 1024 &&
      !e.target.closest(".side-cart")
    ) {
      MainCart.closeCartDrawer();
    }
  });

  // Click on mobile basket icon
  cartBasketMobileIcon.forEach(function (item) {
    item?.addEventListener("click", function (e) {
      if (document.querySelector(".STO-T35-Homepage")) {
        e.preventDefault();
        e.target.removeAttribute("data-href");
        if (document.querySelector(".open-cart__drawer")) {
          MainCart.closeCartDrawer();
        } else {
          // if (cartItemCount > 0) {
          isHovered = true;
          MainCart.openCartDrawer();
          // }
        }
      }
    });
  });

  cartBasketDesktopIcon?.addEventListener("click", function (e) {
    if (window.innerWidth < 1024 && document.querySelector(".STO-T35-Homepage")) {
      e.preventDefault();
      if (document.querySelector(".open-cart__drawer")) {
        MainCart.closeCartDrawer();
      } else {
        // if (cartItemCount > 0) {
        isHovered = true;
        MainCart.openCartDrawer();
        // }
      }
    }
  });

  sidecartBasketMobileIcon?.addEventListener("click", function (e) {
    if (document.querySelector(".STO-T35-Homepage")) {
      e.preventDefault();
      if (document.querySelector(".open-cart__drawer")) {
        MainCart.closeCartDrawer();
      } else {
        // if (cartItemCount > 0) {
        isHovered = true;
        MainCart.openCartDrawer();
        document.body.classList.add("cart__open-with-fixed");
        // }
      }
    }
  });

  /**
   * =================================================================
   * Ajax cart, Fetch cart data and render cart item
   * =================================================================
   */
  // Fetch cart information
  function fetchCart(callback) {
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (typeof callback === "function") {
          callback(cart);
        } else {
          renderCart(cart);
        }
      });
  }

  function addToCartFail() {
    // cartModalContent.innerHTML = "The product you are trying to add is out of stock.";
    // MainCart.openAddModal();
    // MainCart.openCartOverlay();
  }

  // Render Cart Data
  function renderCart(cart) {
    // Clear cart
    MainCart.clearCartDrawer();

    // LineIndex
    var lineIndex = 1;

    // Cart item update
    document.querySelector(".drawer__title #item-count").innerText = cart.items.length;
    cartItemCount = cart.item_count;

    // Cart item
    cart.items.forEach(function (item) {
      let productQuantity = `
            <div class="ajax-cart-item__quantity">
             <button class="quantity-increase" data-line-index="${lineIndex}" data-line-item-id="${item.id}">
               <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect width="24" height="24" fill="#FAECE7"/>
                <path d="M7.5 12H16.5" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 16.5V7.5" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
               </svg>
             </button>
              <span class="quantity-value" data-line-index="${lineIndex}" data-line-item-id="${item.id}">${item.quantity}</span>
              <button class="quantity-decrease" data-line-index="${lineIndex}" data-line-item-id="${item.id}">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect width="24" height="24" fill="#FAECE7"/>
                <path d="M7.5 12H16.5" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              </button>
            </div>`;

      // Product title
      let productTitle =
        '<div class="ajax-cart-item__title"><a class="" href="' +
        item.url +
        '">' +
        item.product_title +
        "</a></div>";

      let productImage =
        '<div class="product-img"><img class="ajax-cart-item__image" src="' +
        item.image +
        '" ></div>';

      let productPrice =
        '<div class="ajax-cart-item__price">$' + (item.line_price / 100).toFixed(2) + "</div>";

      let removeItem =
        '<div class="ajax-cart-item__remove"><button data-line-index="' +
        lineIndex +
        '"><img src="https://cdn.shopify.com/s/files/1/0019/1492/9265/files/cart_icon_close.svg?v=1703179003" alt=""></button></div>';

      let deliveryDateKey = "";
      let deliveryDateValue = "";

      // Keys
      for (let key in item.properties) {
        if (item.properties.hasOwnProperty(key)) {
          let value = item.properties[key];
          deliveryDateKey = `${key}`;
          deliveryDateValue = ` ${value}`;
        }
      }

      // Properties
      var showTheseProps = [
        "Artwork",
        "Finish",
        "Overlamination",
        "Foil Stamping",
        "Numbering",
        "Matte Varnish",
        "White Halo",
        "Sides",
        "Material",
        "Size",
      ];
      var size_found = false;
      var properties = item.properties;

      if (properties["Custom Size"]) {
        delete properties["Size"];
      }
      var props = Object.keys(properties).map((property) => {
        if (property == "Custom Size") {
          size_found = "<span>Size: " + item.properties[property] + "</span>";
          return;
        }

        if ($.inArray(property, showTheseProps) !== -1) {
          return "<span>" + property + ": " + item.properties[property] + "</span>";
        }
      });

      if (size_found !== false) {
        props.unshift(size_found);
      }

      var mainprops = ` ${props.join("")}
        ${
          item.properties["parking-permit-prefix"] &&
          item.properties["Numbering"] == "With Numbering"
            ? "<div>Prefix (ex. A): " + item.properties["parking-permit-prefix"] + "</div>"
            : ""
        }
        ${
          item.properties["parking-permit-starting-number"] &&
          item.properties["Numbering"] == "With Numbering"
            ? "<div>Starting #: " + item.properties["parking-permit-starting-number"] + "</div>"
            : ""
        }
        ${
          item.properties["parking-permit-starting-number"] &&
          item.properties["Numbering"] == "With Numbering"
            ? '<div>Preview: <span id="parking-permit-cart-preview" data-id="' +
              item.key +
              '">' +
              item.properties["parking-permit-preview"] +
              "</span></div>"
            : ""
        }`;

      let productDeliveryDate =
        '<div class="ajax-cart-item__delivery">' + deliveryDateKey + deliveryDateValue + "</div>";

      let concatProductInfo =
        '<div class="single-item">' +
        productImage +
        '<div class="item-info">' +
        productTitle +
        '<div class="product-selected-variant"><div class="current_variant">' +
        mainprops +
        '</div> <div class="product_item__price">' +
        productPrice +
        "</div></div>" +
        '<div class="quantityBox_wrapper">' +
        productQuantity +
        removeItem +
        productPrice +
        "</div>" +
        productDeliveryDate +
        "</div>";

      cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + concatProductInfo;

      lineIndex++;
    });

    // Total cart value
    $(".cart-totals .total-value").text("$" + (cart.total_price / 100).toFixed(2));

    // Click on remove item button
    document.querySelectorAll(".ajax-cart-item__remove button").forEach((button) => {
      button.addEventListener("click", function () {
        MainCart.updateCartQuantity(button.dataset.lineIndex, 0);
      });
    });

    var buttons = document.querySelector(".ajax-cart__drawer .ajax-cart-drawer__buttons");

    // If item available in cart
    if (cart.item_count > 0) {
      if (window.location.pathname != "/cart") {
        // mainCart Open
        MainCart.showModalOnPageload();
      }

      if (buttons) {
        buttons.style.display = "block";
      }

      document.body.setAttribute("data-cart-item-count", true);
    } else {
      if (cartDrawerContent) {
        cartDrawerContent.innerHTML = "Your cart is empty";
      }

      if (buttons) {
        buttons.style.display = "none";
      }

      document.body.removeAttribute("data-cart-item-count");
    }
  }
})();
